import * as React from "react";
import AllUserMessagesContainer from "../../UserMessaging/AllUserMessagesContainer";
import TopBar from "./Ops.UserMessaging.UserMessageGeneralTopBar";

type State = {
  search: string;
};

export default class List extends React.Component<any, State> {
  state = {
    search: ""
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > UserMessaging",
      description: "SnapScan user messaging"
    });
  }

  render() {
    return (
      <React.Fragment>
        <TopBar />
        <section className="padded scrollable">
          <AllUserMessagesContainer name={"ops.user_messaging.list"} />
        </section>
      </React.Fragment>
    );
  }
}
